<template>
    <div>
        <!-- Modal -->
        <div id="openResourceImageAddModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Add Photos</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="w-1/4 mr-4 hidden lg:inline">
                            <file-pond
                                name="test"
                                ref="pondResourceImage"
                                label-idle="Drop multiple photos here or click to upload from your computer. <br><i style='margin-left:6px;' class='fa fa-upload upload-icon-proposal'></i>"
                                allow-multiple="true"
                                :server="resourceServer"
                                :onprocessfile="handleOnProcessResourceFile"
                                :onaddfilestart="handleOnAddFileStart"
                                dropOnPage="true"
                                dropOnElement="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="">

            <div>
                <div class="text-2xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white section-title overflow-hidden">Select Cover Template <button class="btn btn-primary rounded-full ml-2 proposal-editor-save-btn float-right" @click="openCoverImageEditor()" v-if="coverPageImageUrl">Edit Cover Page Image</button></div>
                <div class="col-12 card bg-white shadow mr-2" id="proposalCoverPageDiv">
                    <vue-anka-cropper
                        v-if="coverPageEdit && coverPageImageUrl"
                        :options="{
                           aspectRatio: 1,
                           closeOnSave: true,
                           dropareaMessage: 'Loading Image Please Wait',
                           frameLineDash: [0,0],
                           frameStrokeColor: 'rgba(255, 255, 255, 1.0)',
                           handleFillColor: 'rgba(255, 255, 255, 1.0)',
                           handleHoverFillColor: 'rgba(255, 255, 255, 1.0)',
                           handleHoverStrokeColor: 'rgba(255, 255, 255, 1.0)',
                           handleSize: 13,
                           handleStrokeColor: 'rgba(255, 255, 255, 0.1)',
                           overlayFill: 'rgba(0, 0, 0, 0.1)',
                           previewOnDrag: false,
                           selectButtonLabel: '',
                           showPreview: false,
                           previewQuality: 1,
                           resultQuality: 1,
                           skin: 'light',
                           uploadData: {
                               proposalId:proposal.id
                            },
                           uploadTo:uploadUrl
                        }"
                        @cropper-saved="savedAction(cropData)"
                        @cropper-preview="emitPreview"
                        @cropper-mounted="cropperReady"
                        @cropper-uploaded="cropperUploaded"
                        @cropper-cancelled="cropperCancled"
                    ></vue-anka-cropper>
                    <div class="d-block" style="margin-top: 4rem;margin-bottom: 4rem;" v-if="!tempCoverPageOptions.allCover">
                        <div class="d-inline-block col-md-3 p-0 template-preview" id="cover-template-1" @click="selectCoverTemplate(1)" v-if="tempCoverPageOptions.cover1">
                            <proposal-generator-cover-1 :section="section" :team="team" :proposal="proposal" :selected-resource-file="selectedResourceFile" :cover-logo="coverPageLogo"></proposal-generator-cover-1>
                        </div>
                        <div class="d-inline-block col-md-3 p-0 template-preview" id="cover-template-2" @click="selectCoverTemplate(2)" v-if="tempCoverPageOptions.cover2">
                            <proposal-generator-cover-2 :section="section" :team="team" :proposal="proposal" :selected-resource-file="selectedResourceFile" :cover-logo="coverPageLogo"></proposal-generator-cover-2>
                        </div>
                        <div class="d-inline-block col-md-3 p-0 template-preview" id="cover-template-3" @click="selectCoverTemplate(3)" v-if="tempCoverPageOptions.cover3">
                            <proposal-generator-cover-3 :section="section" :team="team" :proposal="proposal" :selected-resource-file="selectedResourceFile" :cover-logo="coverPageLogo"></proposal-generator-cover-3>
                        </div>
                        <div class="d-inline-block col-md-3 p-0 template-preview" id="cover-template-4" @click="selectCoverTemplate(4)" v-if="tempCoverPageOptions.cover4">
                            <proposal-generator-cover-4 :section="section" :team="team" :proposal="proposal" :selected-resource-file="selectedResourceFile" :cover-logo="coverPageLogo"></proposal-generator-cover-4>
                        </div>
                        <div class="d-inline-block col-md-3 p-0 template-preview" id="cover-template-5" @click="selectCoverTemplate(5)" v-if="tempCoverPageOptions.cover5">
                            <proposal-generator-cover-5 :section="section" :team="team" :proposal="proposal" :selected-resource-file="selectedResourceFile" :cover-logo="coverPageLogo"></proposal-generator-cover-5>
                        </div>
                    </div>
                    <div v-else>
                        <h4 class="text-center p-10">All cover pages are disabled in the selected proposal.</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import axios from "axios";
import Form from "../../../utils/form";
import Swal from "sweetalert2";
import ImageCropper from "../../shared/image-cropper.vue";

let token = document.head.querySelector('meta[name="csrf-token"]');
const FilePond = vueFilePond(FilePondPluginImagePreview, FilePondPluginFileValidateType, FilePondPluginImageExifOrientation, FilePondPluginImageTransform);
import vueAnkaCropper from 'vue-anka-cropper';
export default {
    props: ['section','team', 'proposal', 'selectedResourceFile','selectCoverPageTemplate','proposalCoverOptions', 'selectedProposalType'],
    components: {ImageCropper, FilePond, vueAnkaCropper},
    data() {
        return {
            resourceFiles: [],
            revertedResources: [],
            data_loading: false,
            hasOneFile: false,
            signatureButton: false,
            tempSection: {
                id: this.section.id,
                proposal_id: this.section.proposal_id,
                name: this.section.name,
                include_in_report: this.section.include_in_report,
                order: this.section.order,
                tag: this.section.tag,
                deleteable: this.section.deleteable,
                project: this.project,
                company: this.company,
                companyContact: this.companyContact,
                createdBy: this.createdBy,
                url: this.section.url,
                path: this.section.path,
                token: this.section.token,
                template: this.section.template,
                signature_section: this.section.signature_section,
            },
            signature: this.section.signature_section,
            editName: false,
            server: {
                revert: (uniqueFileId, load, error) => {
                    axios.delete(route('proposal.delete-photo-title-section', {
                        proposal: this.tempSection.proposal_id,
                        proposalInspectionSection: this.tempSection.id,
                    }))
                        .catch((err) => error(err.response.message));
                    load();
                },
                process: (fieldName, file, metadata, load, error, progress) => {
                    const formData = new FormData();
                    formData.append('file', file, file.name);

                    const request = new XMLHttpRequest();
                    request.open('POST', '/proposal/' + this.section.proposal_id + '/proposal-title-section/' + this.tempSection.id + '/upload-photo');
                    request.setRequestHeader('X-CSRF-TOKEN', token.content);

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                        } else {
                            error('oh no');
                        }
                    };
                    request.send(formData);
                }
            },
            resourceServer: {
                revert: (uniqueFileId, load, error) => {
                    let file = JSON.parse(uniqueFileId).resource;
                    this.revertedResources.push(file.token);
                    axios.delete(route('api.resource-files.destroy', {resourceFile: file.token}))
                        .catch((err) => error(err.response.message));
                    load();
                },
                process: (fieldName, file, metadata, load, error, progress) => {
                    const formData = new FormData();
                    // if (this.section.company) formData.append('company_id', this.section.company.id);
                    if (this.section.project.id) formData.append('project_id', this.section.project.id);
                    if (2) formData.append('directory_id', 2);
                    formData.append(fieldName, file, file.name);

                    const request = new XMLHttpRequest();
                    request.open('POST', '/api/proposal-resource-files');
                    request.setRequestHeader('X-CSRF-TOKEN', token.content);

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                        } else {
                            error('oh no');
                        }
                    };

                    request.send(formData);
                    setTimeout(function(){
                        $("#openResourceImageAddModal").modal("hide");
                    }, 3000);
                }
            },
            selecteCoverPageTemplateNumber:(this.selectCoverPageTemplate && this.selectCoverPageTemplate !== 0)? this.selectCoverPageTemplate:this.proposal.cover_template,
            tempCoverPageOptions: (this.proposalCoverOptions)? {
                allCover: this.proposalCoverOptions.all_cover,
                cover1:this.proposalCoverOptions.cover_1,
                cover2:this.proposalCoverOptions.cover_2,
                cover3:this.proposalCoverOptions.cover_3,
                cover4:this.proposalCoverOptions.cover_4,
                cover5:this.proposalCoverOptions.cover_5
            }:{
                allCover:false,
                cover1:true,
                cover2:true,
                cover3:true,
                cover4:true,
                cover5:true
            },
            coverPageLogo: (this.selectedProposalType)? this.selectedProposalType.cover_page_logo:null,
            coverPageImageUrl: (this.selectedResourceFile)? this.selectedResourceFile:null,
            coverPageEdit: false,

            cropData:null,
            uploadUrl: window.location.origin+'/api/proposal/cover-page/image-edit',
            imageSource: null
        }
    },
    mounted() {
        Bus.$on('signature', data => {
            this.tempSection.signature_section = data;
            this.signature = this.tempSection.signature_section;
        });

        Bus.$emit('showButton', { button: 'hideTemplate' });
        Bus.$emit('signature', this.section.signature_section);
        $('#cover-template-'+this.selecteCoverPageTemplateNumber).addClass('template-preview-selected');

        Bus.$on('fetchLatestResourceFile', data => {
            this.fireSuccessToast('Resource file deleted.');
            this.fetchData();
        });
        Bus.$on('removeSelectedCoverImageOnDeletionChild', data => {
            Bus.$emit('selectCoverImage', '');
        });
        Bus.$on('coverOptions', data => {
            this.tempCoverPageOptions.allCover = (data.all_cover == 1)? true:false;
            this.tempCoverPageOptions.cover1 = (data.cover_1 == 1)? true:false;
            this.tempCoverPageOptions.cover2 = (data.cover_2 == 1)? true:false;
            this.tempCoverPageOptions.cover3 = (data.cover_3 == 1)? true:false;
            this.tempCoverPageOptions.cover4 = (data.cover_4 == 1)? true:false;
            this.tempCoverPageOptions.cover5 = (data.cover_5 == 1)? true:false;
        });

        Bus.$on('changeCoverImage', data => {
            this.coverPageEdit = false;
        });
    },
    created() {
        this.fetchData();
    },
    methods: {
        fireSuccessToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'success',
                title: message,
            });
        },
        fireErrorToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'error',
                title: message,
            });
        },
        selectCoverImage(thumbnail, id){

            axios.get('/proposal/'+this.proposal.id+'/proposal-generator/select-resource-file/'+id).then(({data}) => {
                if(data.status == 'success'){
                    Bus.$emit('selectCoverImage', thumbnail);
                    Bus.$emit('selectCoverPageTemplateChild', id);
                    this.fireSuccessToast(data.message);
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        saveTitle() {
            this.editName = false;
            this.$emit('titleChanged', this.tempSection);
        },
        handleOnProcessFile(error, resourceFile) {
            this.tempSection = JSON.parse(resourceFile.serverId).section;
            this.saveTitle();
        },
        handleOnProcessResourceFile(error, resourceFile) {
            setTimeout(() => {
                this.$refs.pondResourceImage.removeFile(resourceFile.id);
                if (!resourceFile.serverId) return;
                let file = JSON.parse(resourceFile.serverId).resource;
                if (this.revertedResources.includes(file.token)) return;
                file.thumb_url = route('resource-files.show-thumb', {resourceFile: file.token});
                file.id_key = file.id;
                this.resourceFiles.unshift(file);
                this.hasOneFile = this.resourceFiles.length > 0;
            }, 2000);
        },
        handleOnAddFileStart() {
            this.hasOneFile = true;

        },
        async uploadFile() {
            let files = this.$refs.responsiveFileInput.files;
            if (files) {
                let i = 0;
                for (i; i < files.length; i++) {
                    const formData = new FormData();

                    // if (this.section.company) formData.append('company_id', this.section.company.id);
                    if (this.section.project.id) formData.append('project_id', this.section.project.id);
                    if (2)  formData.append('directory_id', 2)
                    formData.append('test', files[i]);
                    await axios.post('/api/resource-files', formData).catch(err => {
                        window.Swal.fire({
                            title: "An error occurred!",
                            text: "The file could not be uploaded!",
                            buttons: true,
                        });
                    });
                }
                window.location.reload();
            }
        },
        openResourceImageAddModal() {
            $("#openResourceImageAddModal").modal("show");
        },
        fetchData() {
            let params = {
                // company_id: this.section.company.id,
                project_id: this.section.project.id,
                folder_id: 2,
            };

            this.data_loading = true;
            axios.get(route('api.proposal-resource-files.index'), {params}).then(({data}) => {
                this.resourceFiles = data.data.map(resourceFile => {
                    resourceFile.thumb_url = route('resource-files.show-thumb', {resourceFile: resourceFile.token});
                    resourceFile.is_thumb_loaded = false;
                    resourceFile.id_key = resourceFile.id;
                    return resourceFile;
                });
                this.hasOneFile = this.resourceFiles.length > 0;
                this.pagination = data;
                this.data_loading = false;
            });
        },
        selectCoverTemplate(id){
            axios.get('/proposal/'+this.proposal.id+'/proposal-generator/select-cover-template/'+id).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    Bus.$emit('selectCoverPageTemplateChild', id);
                    $('.template-preview').removeClass('template-preview-selected');
                    $('#cover-template-'+id).addClass('template-preview-selected');
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        signatureFooter() {
            Bus.$emit('signature', !this.signatureButton);
        },
        deleteProposal() {
            let self = this;
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this proposal!",
                icon              : "warning",
                buttons           : true,
                showCancelButton  : true,
                confirmButtonColor: 'red',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.delete(route('proposal.destroy', self.proposal.id))
                        .then((response) => {
                            if (response.data.status === 'success') {
                                window.location = '/project/' + response.data.project_id + '/edit';
                            } else {
                                self.initTempProposal(response.data.proposal);
                                self.fireErrorToast(response.data.message);
                            }
                        });
                }
            });
        },
        unlock() {
            let self = this;
            axios.put('/proposal/' + self.proposal.id + '/unlock')
                .then((response) => {
                    if (response.data.status === 'success') {
                        self.fireSuccessToast(response.data.message);
                        window.location.reload();
                    } else {
                        self.fireErrorToast(response.data.message);
                        self.initTempProposal(response.data.proposal);
                    }
                });
        },
        lock() {
            let self = this;
            axios.put('/proposal/' + self.proposal.id + '/lock')
                .then((response) => {
                    if (response.data.status === 'success') {
                        self.fireSuccessToast(response.data.message);
                        window.location.reload();
                    } else {
                        self.fireErrorToast(response.data.message);
                        self.initTempProposal(response.data.proposal);
                    }
                });
        },
        showResourceDeleteButton(id){
            var myElement = document.getElementById('resource-delete-'+id);
            myElement.style.setProperty('display','block', 'important');
        },
        hideResourceDeleteButton(id){
            var myElement = document.getElementById('resource-delete-'+id);
            myElement.style.setProperty('display','none', 'important');
        },
        deleteResourceFile(resourceFile){
            Bus.$emit('delResourceFile', resourceFile);
        },
        openCoverImageEditor(){
            this.coverPageEdit = true;
        },
        covePageEditClose(){
            this.coverPageEdit = false;
        },

        savedAction(cropData){
            console.log('here', cropData);
        },
        afterSavedAction(cropData){
            // $('#uploadAndCropImage').modal('hide');
            // this.$parent.fetchPGTemplateInfo();
        },
        emitPreview(imageSource){
            Bus.$emit('selectCoverImage', imageSource);
        },
        cropperReady(){
            setTimeout(() => {
                this.cropperAfterReady();
            }, 3000);
        },
        async cropperAfterReady(){
            const response = await fetch(this.coverPageImageUrl);
            const blob = await response.blob();
            const file = new File([blob], 'image.jpeg', { type: blob.type });

            const dropEvent = new DragEvent('drop', {
                dataTransfer: new DataTransfer(),
            });
            dropEvent.dataTransfer.items.add(file);

            const dropZone = document.getElementsByClassName('ankaCropper__droparea')[0];
            dropZone.dispatchEvent(dropEvent);
        },
        cropperUploaded(){
            window.location.reload();
        },
        cropperCancled(){
            this.coverPageEdit = false;
        },
    },
    watch: {
        'selectedProposalType': function(val){
            this.coverPageLogo = this.selectedProposalType.cover_page_logo;
        }
    }
}
</script>

<style scoped>
.reports-frame-style {
    height: 75vh;
    width: 100%;
    border: 1px solid grey;
    border-radius: 7px;
}
.resource-images-div {
    float: left;
    padding: 0 5px;
    margin-bottom: 10px;
    height: 100px;
}
span.resource-images-name {
    font-size: 10px;
    word-break: break-word;
}
.resource-images {
    height: 55px;
}
.resource-images:hover{
    cursor: pointer;
}
.template-preview .one-page{
    /*zoom: 0.3;*/
    transform: scale(0.3);
    transform-origin: 0 0;
    -moz-transform: scale(0.3);
    -moz-transform-origin: 0 0;
    -ms-transform: scale(0.3);
    -ms-transform-origin: 0 0;
    -webkit-transform: scale(0.3);
    -webkit-transform-origin: 0 0;
}
.template-preview .w-3\/5 {
    width: 334% !important;
}
.template-preview:hover{
    box-shadow: 0px 0px 10px 0px #01b1af;
    cursor: pointer;
}
.template-preview-selected{
    box-shadow: 0px 0px 10px 0px #01b1af !important;
}
.template-preview{
    max-width: 22% !important;
    margin: 0 10px 15px;
    box-shadow: 0px 0px 10px 0px silver;
    overflow: hidden;
    height: 18.5rem;
}
.resource-images-div {
    float: left;
    padding: 0 5px;
    margin-bottom: 10px;
    height: 100px;
    overflow:hidden;
}
.resource-images-div img{
    height:60px;
}
span.resource-images-name {
    font-size: 10px;
    word-break: break-word;
}
.resource-images {
    height: 55px;
}
.tool-buttons {
    border: 1px solid #01b1af;
    margin: 0 5px;
    font-size: 12px;
    padding: 10px 0;
    color: #01b1af;
    text-align: center;
    margin-bottom: 9px;
    max-width: 93% !important;
    margin-right: 5px;
    margin-left: 7px;
}
.tool-buttons:hover {
    background-color: #01b1af1c;
    cursor: pointer;
}
.deleteBtn {
    color: #dc3545 !important;
    border-color: #dc3545 !important;
    max-width: 95% !important;
}
.deleteBtn:hover{
    background-color: #dc35451c !important;
}
.upload-icon-proposal {
    font-size: 18px;
    margin-left: 2px;
}
.upload-btn-proposal:hover{
    border: 1px solid #fff;
    padding: 0 10px;
    border-radius: 5px;
    background: #fff;
    color: #01b1af !important;
}
.upload-btn-proposal{
    border: 1px solid #fff;
    padding: 0 10px;
    border-radius: 5px;
    background: #01b1af;
    color: #fff !important;
    cursor: pointer;
}
.section-title{
    width: 100%;
    height: 53px;
    overflow: hidden;
    font-size: 18px !important;
    padding: 15px !important;
}
.delete-resource-file-button {
    width: 20px;
    height: 20px;
    font-size: 12px;
    background: red;
    text-align: center;
    color: white;
    position: absolute;
    top: 0px;
    z-index: 999;
    display: none;
    cursor: pointer;
}
.proposal-editor-save-btn {
    background: #fff;
    border: 1px solid #01b1af;
    color: #01b1af;
    font-size: 12px;
    margin-top: -5px;
}

</style>
<style>
#proposalCoverPageDiv .ankaCropper__selectButton{
    display: none;
}
#proposalCoverPageDiv .ankaCropper__droparea div{
    background-image: none;
    ont-size: 25px;
    font-weight: 400;
}
</style>
